import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as removeAccents from 'remove-accents';
import { ContractAssignor, UpdateContractAssignor } from 'src/app/models/contract-assignor';
import { ProdutoCategoria } from 'src/app/models/produto-categoria';
import { CartaoService } from 'src/app/services/cartao.service';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { CategoriaProduto } from 'src/app/shared/enums/categoria-produto.enum';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';
import { DropDownItem } from 'src/app/shared/helpers/models/dropdown-item';
import { Auth } from '../../../../../models/auth';
import { CedenteContrato } from '../../../../../models/cedente-contrato';
import { ProdutoElegibilidade } from '../../../../../models/produto-elegibilidade';
import { ResponseBase } from '../../../../../models/response-base';
import { TermoUso } from '../../../../../models/termo-uso';
import { TutorialProgresso } from '../../../../../models/tutorial';
import { AuthenticationService } from '../../../../../services/authentication.service';
import { ContratoService } from '../../../../../services/contrato.service';
import { ProdutoElegivelService } from '../../../../../services/produto-elegivel.service';
import { TermoUsoService } from '../../../../../services/termo-uso.service';
import { TutorialService } from '../../../../../services/tutorial.service';
import { ApiError } from '../../../../../shared/enums/api-error.enum';

@Component({
    selector: 'app-novo-beneficio-contratar',
    templateUrl: './novo-beneficio-contratar.component.html',
    styleUrls: ['./novo-beneficio-contratar.component.css']
})
export class NovoBeneficioContratarComponent implements OnInit {

    @ViewChild('drawer') drawer: MatSidenav;
    public newContratoForm: FormGroup;

    filtroPesquisa: string;
    private idProdutoElegivel: number;

    private currentUser: Auth;
    public produtoElegibilidade: ProdutoElegibilidade[];
    public produtoElegibilidadeList: ProdutoElegibilidade[];
    public cedenteContrato: CedenteContrato;
    public contractAssignor: ContractAssignor;
    public termoUso: TermoUso;
    public termoUsoUrl: any;
    public isFlex;
    public isLog;
    public cartaoPeriodosPadroes: DropDownItem[] = [];
    cartaoPeriodoPadrao = [];
    hasStandardPeriod: boolean = false;
    private parametros: { [key: string]: string };

    public categoriaProduto = CategoriaProduto;
    public category: any = 1;
    public checked = false;
    public acceptedTermo = false;
    isEmpty = false;
    permitirValorIncremento = false;

    //#region Paginação
    currentPage = 1;
    showItem = '25';

    //#endregion

    //#region Tutorial
    public progresso: TutorialProgresso;

    //#endregion

    //#region ErrosMessages
    public messageValorPadrao: string;
    public messageValorMaximo: string;
    public messageValorIncremento: string;
    public messageTermo: string;
    public messageErro: string;
    public inValorPadraoInvalid: boolean = false;
    public inValorMaximoInvalid: boolean = false;
    public inValorIncrementoInvalid: boolean = false;
    public isTermoInvalid: boolean = false;
    public produtoCategoria: ProdutoCategoria[];
    cedenteContratoList: CedenteContrato[];
    isFlexAllowed: boolean = false;
    //#endregion

    constructor(
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private produtoElegibilidadeService: ProdutoElegivelService,
        private termoUsoService: TermoUsoService,
        private modalService: NgbModal,
        private contratoService: ContratoService,
        private tutorialService: TutorialService,
        private cartaoService: CartaoService,
        private parametrosDataService: ParametrosDataService,
        private formBuilder: FormBuilder) {
    }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.produtoCategoria = JSON.parse(localStorage.getItem('productCategory'));
        this.produtoCategoria = this.produtoCategoria.filter(el => el.canList && el.id != CategoriaProduto.Flex);
        this.produtoCategoria.sort((a, b) => (a.categoryListOrder > b.categoryListOrder) ? 1 : -1);
        this.parametros = this.parametrosDataService.currentParametrosValue;
        if (this.parametros[ParametrosKey.permitirValorIncremento]) {
            this.permitirValorIncremento = BooleanConverter.getBoolean(
                this.parametros[ParametrosKey.permitirValorIncremento]
            );
        } else {
            this.permitirValorIncremento = false;
        }
        this.createForm();
        this.load();
    }

    createForm() {
        this.newContratoForm = this.formBuilder.group({
            valorPadrao: new FormControl(0, [
                Validators.required,
                Validators.min(0)
            ]),
            valorMaximoBeneficio: new FormControl(null),
            valorIncremento: new FormControl(null),
            ehEditavel: new FormControl(true, [
                Validators.required
            ]),
            cartaoPeriodoPadraoId: new FormControl([''], [
                Validators.required
            ]),
            termoUsoAceito: new FormControl(this.acceptedTermo)
        });
    }

    load() {
        this.contratoService.getContractsAssignorProducts(this.currentUser.token.assignorGuid).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.isFlexAllowed = false;
                    const contain = [CategoriaProduto.Tradicional];
                    let beneficios = response.result;
                    beneficios = beneficios.filter(item => contain.includes(item.categoriaProduto))
                    if (beneficios.length > 2) {
                        this.isFlexAllowed = true;
                        // this.messageErro = response.message;
                    }
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Erro ao carregar os produtos' + error);
            }
        );

        this.cartaoService.getAllCartaoPeriodoPadrao().subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    response.result.forEach(obj => {
                        this.cartaoPeriodoPadrao = [{
                            id: obj.valor.toString(),
                            descricao: obj.descricao
                        }];
                        this.cartaoPeriodosPadroes.push(new DropDownItem(obj.valor.toString(), obj.descricao));
                    });
                }
            }, error => { console.log(error); }
        );

        this.produtoElegibilidadeService.getProdutosElegivel(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, 1).subscribe(
            response => {
                this.isEmpty = false;
                this.checked = true;
                this.produtoElegibilidade = response.result;
                this.produtoElegibilidadeList = response.result;
                for (const s of this.produtoElegibilidadeList) {
                    s.produto.produtoGuid = s.produto.produtoGuid.toLowerCase();
                }

                if (this.produtoElegibilidadeList.length <= 0 && this.produtoElegibilidade.length <= 0) {
                    this.isEmpty = true;
                    this.messageErro = response.message;
                }
                /* [CCS 20240904]: Commented the tutorialService.getProgresso to make it work
                this.tutorialService.getProgresso(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, 'homeCedente')
                    .subscribe((resp: ResponseBase<TutorialProgresso>) => {
                        if (resp.status === ApiError.Sucesso) {
                            this.progresso = resp.result;
                            if (this.produtoElegibilidade.length <= 0) {
                                this.updateProgressoTutorial();
                            }
                        }
                    }, error => {
                        console.log(error);
                    });
                */


            }
        );
    }

    changeCategory(e,vcategory: number = 0) {

        if(this.drawer.opened)
            this.drawer.toggle();

        if(e != null && vcategory == 0){
            this.category = e.target.value;
        }
        if(vcategory != 0)
            this.category = vcategory;
        this.produtoElegibilidadeService.getProdutosElegivel(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, this.category).subscribe(
            response => {
                this.isEmpty = false;
                this.produtoElegibilidade = response.result;
                this.produtoElegibilidadeList = response.result;
                for (const s of this.produtoElegibilidadeList) {
                    s.produto.produtoGuid = s.produto.produtoGuid.toLowerCase();
                }

                if (this.produtoElegibilidadeList.length <= 0 && this.produtoElegibilidade.length <= 0) {
                    this.isEmpty = true;
                    // this.messageErro = response.message;
                }
                /* [CCS 20240904]: Commented the tutorialService.getProgresso to make it work
                this.tutorialService.getProgresso(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, 'homeCedente')
                    .subscribe((resp: ResponseBase<TutorialProgresso>) => {
                        if (resp.status === ApiError.Sucesso) {
                            this.progresso = resp.result;
                            if (this.produtoElegibilidade.length <= 0) {
                                this.updateProgressoTutorial();
                            }
                        }
                    }, error => {
                        console.log(error);
                    });
                */


            }
        );
    }

    isAllowed(){
        if(this.isFlexAllowed || this.isLog)
            this.onSubmit(null);
        else{
            this.alertService.warning("Você deve aderir pelo menos 2 ou mais produtos benefícios!");
            this.changeCategory(null,1);
        }

    }

    readTermo(e){
        if(e.target.checked){
            this.modalService.open(this.termoUsoUrl, {centered: true, size: 'lg'});
            this.acceptedTermo;
        }
    }

    showTermo(content, produtoGuid: string, produtoElegibilidadeId: number, listProdutos: ProdutoElegibilidade) {

        this.isFlex = listProdutos.produto.produtoCategoria == 2;
        this.isLog = listProdutos.produto.produtoCategoria == 7;
        this.form.valorPadrao.setValue(null);
        this.form.valorPadrao.clearValidators();
        this.form.valorMaximoBeneficio.setValue(null);
        if(!this.isFlex && !this.isLog)
            this.form.valorMaximoBeneficio.clearValidators();
        this.form.valorIncremento.setValue(null);
        this.form.ehEditavel.setValue(true);
        if(listProdutos.produto.produtoPeriodoPadrao === null){
            this.hasStandardPeriod = false;
            this.form.cartaoPeriodoPadraoId.setValue(1);
        }
        else{
            this.hasStandardPeriod = true;
            this.cartaoPeriodoPadrao = [{
                id: listProdutos.produto.produtoPeriodoPadrao,
                descricao: this.cartaoPeriodosPadroes.find(x=>x.ITEM_ID === listProdutos.produto.produtoPeriodoPadrao.toString()).ITEM_TEXT
            }]
            this.form.cartaoPeriodoPadraoId.setValue(listProdutos.produto.produtoPeriodoPadrao);
        }
        this.form.cartaoPeriodoPadraoId.clearValidators();
        this.acceptedTermo = false;
        this.form.termoUsoAceito.setValue(this.acceptedTermo);
        this.termoUsoService.getTermoUso(produtoGuid).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.termoUso = response.result;
                    /* console.log(this.termoUso) */
                    this.idProdutoElegivel = produtoElegibilidadeId;

                    if(this.category == CategoriaProduto.Incentivo || this.category == CategoriaProduto.IncentivoPlus){
                        this.form.cartaoPeriodoPadraoId.setValue(3);
                    }

                    if(this.isFlex || this.isLog){
                        this.acceptedTermo = true;

                        this.modalService.open(content, {centered: true, size: 'lg'});
                    }
                    if (this.termoUso.url) {
                        this.drawer.toggle();
                        this.termoUsoUrl = content;
                      //  if(false)
                        //  this.modalService.open(content, {centered: true, size: 'lg'});
                    } else if(!this.isFlex && !this.isLog){
                        if(!this.drawer.opened)
                            this.drawer.toggle();
                        this.acceptedTermo = true;
                        //this.modalService.open(content, {centered: true, size: 'sm'});
                    }


                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Erro ao carregar termo de uso do produto! Por favor tente novamente mais tarde.');
            }
        );
    }

    //acceptTermo(valorPadrao: number = 0, cartaoPeriodoPadraoId: number, ehEditavel: boolean, valorMaximoBaneficio: number = 0, valorIncremento: number = 0){
    onSubmit(contractAssignor: CedenteContrato){

        if(this.isFlex || this.isLog){
            this.acceptTermoNoConfig();
        }

        if(this.newContratoForm.invalid){
            this.newContratoForm.markAllAsTouched();
        }

        if(!this.form.termoUsoAceito.value && !this.acceptedTermo){
            this.isTermoInvalid = true;
            this.messageTermo = 'Aceite o termo para aderir ao produto';
        }

        if(this.newContratoForm.controls.valorPadrao === null){
            this.newContratoForm.controls.valorPadrao.markAsTouched();
        }

        if(this.newContratoForm.valid){
            /*
            if(cedenteContrato.valorMaximoBeneficio == undefined || cedenteContrato.valorMaximoBeneficio < cedenteContrato.valorPadrao || cedenteContrato.valorMaximoBeneficio <= 0){
                cedenteContrato.valorMaximoBeneficio = cedenteContrato.valorPadrao;
            }

            if(cedenteContrato.valorIncremento <= 0){
                cedenteContrato.valorIncremento = 1;
            }

            if(!cedenteContrato.ehEditavel){
                cedenteContrato.valorMaximoBeneficio = cedenteContrato.valorPadrao;
                cedenteContrato.valorIncremento = cedenteContrato.valorPadrao;
            }*/
        /*
        valorPadrao = parseFloat(valorPadrao.toString());
        valorMaximoBaneficio = parseFloat(valorMaximoBaneficio.toString());
        valorIncremento = parseFloat(valorIncremento.toString());

        if(valorPadrao <= 0 || isNaN(valorPadrao)){
            this.inValorPadraoInvalid = true;
            this.messageValorPadrao = 'O valor padrão deve ser maior que zero!';
        }
        else
            this.inValorPadraoInvalid = false;
        */
        if (contractAssignor.valorMaximoBeneficio > 0 && contractAssignor.valorMaximoBeneficio < contractAssignor.valorPadrao/* || valorMaximoBaneficio <= 0 || isNaN(valorMaximoBaneficio)*/){
            this.inValorMaximoInvalid = true;
            this.messageValorMaximo = 'O valor máximo deve ser maior ou igual ao valor padrão do produto!';
        }
        else
            this.inValorMaximoInvalid = false;

        /*
        if(valorIncremento <= 0 || isNaN(valorIncremento)){
            this.inValorIncrementoInvalid = true;
            this.messageValorIncremento = 'O valor de incremento deve ser maior que zero!';
        }
        else
            this.inValorIncrementoInvalid = false;

        if(!this.acceptedTermo){
            this.isTermoInvalid = true;
            this.messageTermo = 'Aceite o termo para aderir ao incentivo';
        }
        else{
            this.isTermoInvalid = false;
        }
        */
        if(/*!this.inValorPadraoInvalid &&*/ !this.inValorMaximoInvalid/* && !this.inValorIncrementoInvalid*/){
            this.contratoService.createContract(this.idProdutoElegivel, this.currentUser.token.assignorGuid).subscribe(
                response => {
                    if (ApiError.Sucesso === response.status) {
                        this.contractAssignor = response.result;
                        const updateContractAssignor = new UpdateContractAssignor(contractAssignor.valorPadrao, +contractAssignor.cartaoPeriodoPadraoId, contractAssignor.ehEditavel, contractAssignor.valorMaximoBeneficio, contractAssignor.valorIncremento);
                        this.contratoService.updateContract(this.contractAssignor.id, this.currentUser.token.assignorGuid, updateContractAssignor).subscribe(
                            response => {
                                if (response.status === ApiError.Sucesso) {
                                    this.drawer.toggle();
                                    this.changeCategory(null,this.category)
                                    this.updateProgressoTutorial();
                                    this.alertService.success('Produto contratado com sucesso!');
                                } else {
                                    this.alertService.error(response.message);
                                }
                            }, error => { console.log(error); }
                        );
                    } else {
                        this.alertService.error('Erro ao contratar produto! Por favor tente novamente mais tarde.');
                    }
                },
                error => {
                    this.alertService.error('Erro ao solicitar contratação termo de uso do produto! Por favor tente novamente mais tarde.');
                }
            );
        }
        }
    }

    acceptTermoNoConfig(){

        this.contratoService.createContract(this.idProdutoElegivel, this.currentUser.token.assignorGuid).subscribe(
            response => {
                if (ApiError.Sucesso === response.status) {
                    this.contractAssignor = response.result;
                    /* console.log(this.cedenteContrato) */
                    if(this.isFlex || this.isLog){
                        this.updateProgressoTutorial();
                        window.location.href = window.location.href;
                    }else{
                        this.changeCategory(null,this.category)
                        this.updateProgressoTutorial();
                    }
                } else {
                    this.alertService.error('Erro ao contratar produto! Por favor tente novamente mais tarde.');
                }
            },
            error => {
                this.alertService.error('Erro ao solicitar contratação termo de uso do produto! Por favor tente novamente mais tarde.');
            }
        );
    }

    searchFilter() {
        if (!this.filtroPesquisa) {
            return this.produtoElegibilidadeList = this.produtoElegibilidade;
        } else {
            this.produtoElegibilidadeList = this.produtoElegibilidade;
            this.produtoElegibilidadeList = this.produtoElegibilidadeList.filter(
                s => removeAccents(s.produto.descricao).toLocaleLowerCase().includes(removeAccents(this.filtroPesquisa).toLocaleLowerCase())
            );
        }
    }

    private updateProgressoTutorial() {
        /* [CCS 20240904]: Commented the tutorialService.getProgresso to make it work
        this.progresso = new TutorialProgresso();
        this.tutorialService.getProgresso(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, 'homeCedente').subscribe((resp: ResponseBase<TutorialProgresso>) => {
            if (resp.status === ApiError.Sucesso) {

                this.progresso.ativo = resp.result.ativo;
                this.progresso.ordemAtividade = (resp.result.progresso / 20);
                this.progresso.idCedente = this.currentUser.token.assignorGuid;
                this.progresso.idGestor = this.currentUser.token.userReferenceId;
                this.progresso.nomeTutorial = 'homeCedente';
                if (this.progresso.ordemAtividade === 2) {
                    this.progresso.ordemAtividade++;
                    this.tutorialService.updateProgresso(this.progresso).subscribe(r => {
                    });
                }
            }
        }, error => {
            console.log(error);
        });
        */
        /* this.tutorialService.updateProgresso(this.tutorialService.createAtualizarProgresso(3)).subscribe((resp: ResponseBase<TutorialProgresso>) => {
            if (resp.status === ApiError.Sucesso) {
                this.progresso = resp.result;
                const passo = this.tutorialService.getLocalStoragePassoAtual;
                passo.alreadyDone = true;
                this.tutorialService.setLocalStoragePassoAtual(passo);
            }
        }, error => {
            console.log(error);
        }); */
    }

    close() {
        this.drawer.toggle();
    }

    public get form() {
        return this.newContratoForm.controls;
    }

    aceito(){
        this.isTermoInvalid = false;
    }
}
